import {
  Breakpoint,
  DialogProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useState } from 'react';

export const useDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  return {
    isOpen,
    setOpen: () => setIsOpen(true),
    setClosed: () => setIsOpen(false),
  };
};

export const useMuiDialog = (maxWidth: Breakpoint = 'sm') => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const isMobileViewport = useMediaQuery(theme.breakpoints.down('sm'));
  const props: DialogProps = {
    open: isOpen,
    maxWidth,
    fullWidth: true,
    fullScreen: isMobileViewport,
  };
  return {
    setOpen: () => setIsOpen(true),
    setClosed: () => setIsOpen(false),
    props,
  };
};
